import { RECORDING_MODES } from "../recordingModes";

const MODE_CONFIG = {
  [RECORDING_MODES.SPIROMETRY]: {
    variant: "RecordingSpirometry",
    segment: "spirometry",
  },
  [RECORDING_MODES.TIDAL]: {
    variant: "RecordingTidalBreathing",
    segment: "tidal-breathing",
  },
  [RECORDING_MODES.PULSE]: {
    variant: "RecordingPulseScan",
    segment: "pulse-scan",
  },
  [RECORDING_MODES.MAUDIO]: {
    variant: "RecordingManualAudio",
    segment: "manual-audio",
  },
  [RECORDING_MODES.POSTEXERTION]: {
    variant: "RecordingPostExertion",
    segment: "post-exertion",
  },
  [RECORDING_MODES.SIX_MINUTE_WALK]: {
    variant: "RecordingSixMinuteWalk",
    segment: "six-minute-walk",
  },
};

export function getRecordingModeDestination(mode, firstRunByVariant = {}) {
  const config = MODE_CONFIG[mode];
  if (!config) return "/";

  if (mode === RECORDING_MODES.SIX_MINUTE_WALK) {
    return `/recording/${config.segment}`;
  }

  const step = firstRunByVariant[config.variant] ? "guide" : "camera";
  return `/recording/${config.segment}/${step}`;
}

export function getReviewMetadataPath(nextPath, mode) {
  const params = new URLSearchParams();
  if (mode) params.set("mode", mode);
  params.set("next", nextPath || "/");
  return `/review-metadata?${params.toString()}`;
}

export function getSafeInternalNextPath(value, fallback = "/") {
  if (typeof value !== "string") return fallback;
  if (!value.startsWith("/") || value.startsWith("//")) return fallback;
  return value;
}
